const isProduction = () => process.env.STAGE_NAME === 'prod';
export default isProduction;
